import IconButton from '@/components/ui/IconButton'
import Image from 'next/image'

type Props = {
	gallery: { url: string; alt: string }[]
	activeImageIndex: number
	setActiveImageIndex: React.Dispatch<React.SetStateAction<number>>
}

export default function CarouselInModal({ gallery, activeImageIndex, setActiveImageIndex }: Props) {
	const updateImageIndex = (currentIndex: number, direction: 'next' | 'prev') => {
		const lastIndex = gallery.length - 1
		if (direction === 'next') {
			return currentIndex === lastIndex ? 0 : currentIndex + 1
		} else {
			return currentIndex === 0 ? lastIndex : currentIndex - 1
		}
	}

	return (
		<div className="flex max-lg:flex-col items-center justify-center gap-2">
			{/* Desktop Previous Button */}
			{gallery.length > 1 && (
				<IconButton
					icon="Arrow"
					onClick={() => setActiveImageIndex((prevIndex) => updateImageIndex(prevIndex, 'prev'))}
					aria-label="Previous image"
					className="rotate-180 disabled:opacity-100 max-lg:hidden"
					variant="solid-white-shade"
				/>
			)}
			<div className="relative flex items-center justify-center w-full h-[calc(50vh-96px)] xl:h-[calc(80vh-112px)]">
				<Image
					src={gallery?.[activeImageIndex]?.url}
					alt={gallery?.[activeImageIndex]?.alt ?? 'Product Image'}
					width={150}
					height={150}
					className="object-contain rounded-lg w-full h-full lg:max-w-fit lg:max-h-fit bg-white-frosted"
					sizes="90vw"
				/>
				<span className="font-mono text-contrast-low text-sm absolute max-lg:-bottom-10 max-lg:left-2 -bottom-8 lg:left-1/2 lg:-translate-x-1/2">
					{activeImageIndex < 9 && '0'}
					{activeImageIndex + 1} / {gallery.length < 9 && '0'}
					{gallery.length}
				</span>
			</div>

			{gallery.length > 1 && (
				<div className="flex justify-end lg:justify-center gap-2 max-lg:w-full px-2 max-lg:mt-2">
					{/* Mobile Previous Button */}
					<IconButton
						icon="Arrow"
						onClick={() => setActiveImageIndex((prevIndex) => updateImageIndex(prevIndex, 'prev'))}
						aria-label="Previous image"
						className="rotate-180 disabled:opacity-100 lg:hidden"
						variant="solid-white-shade"
					/>
					<IconButton
						icon="Arrow"
						onClick={() => setActiveImageIndex((prevIndex) => updateImageIndex(prevIndex, 'next'))}
						aria-label="Next image"
						className="disabled:opacity-100"
						variant="solid-white-shade"
					/>
				</div>
			)}
		</div>
	)
}
